import styled from "styled-components";
import NavBack from "../../assets/icon/lnb_next_arrow.png";

export const Page = styled.div`
  min-height: calc(100vh - 68px);
  padding-top: 68px;
  width: 100vw;
  background-color: var(--semi-brown);
  margin-bottom: 60px;
  .section {
    box-shadow: 5px 5px 5px rgba(54, 28, 11, 0.1);
    background-color: var(--white);
    min-height: 800px;
    width: 1280px;
    margin: auto;
    border: 1px solid #d9d1ca;
    @media (max-width: 1280px) {
      width: 90vw;
    }
  }

  .inner {
    width: 100%;
    box-sizing: border-box;
    padding: 0px 50px 60px 50px;
    @media (max-width: 1024px) {
      padding: 0px 12px 24px 12px;
    }
  }
.link-line-text{
span{
display: inline-block;
  width : 160px;
}


a {
    display: inline-block;
    margin-left: 24px;
    border-radius: 10px;
    cursor: pointer;
    font-size : 14px;
    background-color: var(--pink);
    color: var(--white);
    margin-top: 4px;
    padding: 4px 12px;
  }
}
  .page-text {
    padding: 0 30px 0px 30px;
    width: 100%;
    box-sizing: border-box;
    position: relative;
    line-height: 1.9;
    font-size: 18px;
    margin-top: 24px;

    .page-text-flex {
      display: flex;
      gap: 60px;
      margin-bottom: 24px;
    }

    .page-text-title {
      font-weight: bold;
      font-size: 24px;
      margin-top: 24px;
    }
        @media (max-width: 768px) {
      font-size: 14px;
      padding: 0 12px 0px 12px;
      word-break: keep-all;
      margin-top: 12px;
.mt-4 {
    margin-top: 16px;
  }

  .mb-2 {
    margin-bottom: 8px;
  }
  .date {
    display : block;
    margin-top : 8px;
  }
      .hat-img {
        position: relative !important;
        top: auto !important;
        left: auto !important;
        right: auto !important;
        bottom: auto !important;
        transform: none !important;
        height: auto !important;
        width: 100% !important;
      }
    }
    .page-text-flex {
      display: block;
      > div {
        width: 100%;
        margin-bottom: 12px;
      }
    }
    .page-text-title {
      font-size: 16px;
    }
  }
  }

  .hat-img {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 0;
    height: 300px;
  }

  .hat-img-lg{
    height: 450px;
  
  }

  .fullsize-map {
    width: 100%;
    border-radius: 10px;
    margin-top: 30px;
  }

  .education-map {
    position: relative;
    width: 100%;
    margin-top: 30px;

    .fullsize-map {
      display: block;
      width: 100%;
      margin-top: 0;
    }

    .map-link {
      position: absolute;
      display: block;
      z-index: 10;
      cursor: pointer;
    }
  }

  /* =========================
    한글 이미지
    ========================= */
  .education-map.kor-map {
    .map-link {
      left: 52.8%;
      width: 9%;
      height: 3%;
    }

    .university {
      top: 3.4%;
    }

    .highschool {
      top: 23.5%;
    }

    .middleschool {
      top: 43.6%;
    }

    .elementary {
      top: 63.7%;
    }

    .kindergarten {
      top: 84.8%;
    }
  }


  /* =========================
    영문 이미지
    ========================= */
  .education-map.eng-map {
    .map-link {
      left: 54.8%;
      width: 8%;
      height: 3.4%;
    }

    .university {
      top: 14.4%;
    }

    .highschool {
      top: 35.0%;
    }

    .middleschool {
      top: 55.3%;
    }

    .elementary {
      top: 75.4%;
    }

    .kindergarten {
      top: 95.5%;
    }
  }


  .mt-4 {
    margin-top: 24px;
  }

  .mb-2 {
    margin-bottom: 12px;
  }

  .date {
    width: 120px;
    display: inline-block;
    font-weight: bold;
  }

  .page-subtitle {
    font-size: 24px;
    padding-left: 30px;
    margin-top: 16px;
  }

  .page-img-list {
    width: 100%;
    margin-top: 24px;
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
  }

  .page-img-item {
    width: calc((100% - 24px) / 3);
  }

  @media (max-width: 768px) {
   .page-subtitle{
  font-size: 18px;
  padding-left : 12px;
 
}
  }

  .title-flex{
  display: flex;
  align-items : center;
  justify-content : space-between;
  padding-top : 45px;
  &>div{
    padding-top : 0px !important;
  }
  span{
  height : 100%;
  display : flex;
  align-items : center;
  font-size : 24px;
  font-weight : bold;
  }

  @media (max-width: 768px) {
  display : block;

  span{
    font-size : 18px;
    margin-top : 12px;
  }
}
}

 &.kor {
    .kor {
      display: block;
    }

    .eng {
      display: none;
    }
  }

  &.eng {
    .kor {
      display: none;
    }

    .eng {
      display: block;
    }
  }
`;

export const PageTopLine = styled.div`
  width: 1280px;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 40px;
  padding-bottom: 40px;

  .page-top-line-title {
    font-size: 40px;
    color: var(--dark);
    font-weight: bold;
  }
  .page-top-line-left {
    img {
      width: 140px;
    }
  }
  .page-top-line-right {
    width: 140px;
  }
  @media (max-width: 1280px) {
    width: 90vw !important;
    margin: auto;
    display: block;
    text-align: center;
  }
`;
export const PageNavidation = styled.div`
  background-color: #faf8f6;
  box-shadow:0 2px 2px rgba(54,28,11,.05);
  border-bottom : 1px solid #ccc;
  height : 52px;
  display : flex;
  align-items : center;
 
  .logo{
    width : 80px;
    height : 100%;
    display : flex;
    align-items : center;
    justify-content : center;
    background-image: url(${NavBack}) ;
    background-repeat: no-repeat;
    background-position : right;
    svg{
      width : 13px;
      height : 11px;
    }
}

@media (max-width: 768px){

  &>div:nth-child(-n+2) {
    display : none !important;
  }

  &>a{
    display : none !important;
  }
    &>div{
      width : auto !important;
      padding-right : 60px;
      a{
      font-size : 14px;
      }
    }

  .open-list{
    left : 0px !important;
  font-size : 14px;
    }
}


.`;

export const Nav = styled.div`
  background-image: url(${NavBack});
  background-repeat: no-repeat;
  background-position: right;
  width: 24%;
  height: 52px;
  position: relative;
  .down-arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 32px;
  }

  cursor: pointer;
  &:hover .open-list,
  .open-list:hover {
    height: ${(props) => props.height};
    border: 1px solid #ccc;
    background-color: var(--white);
  }

  .open-list {
    position: absolute;
    top: 52px;
    left: -24px;
    box-sizing: border-box;
    z-index: 50;
    height: 0px;
    transition: all 0.2s ease-in-out;
    overflow: hidden;
    width: 100%;
    border: none;
  }
`;
export const NavItem = styled.div`
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: left;
  font-size: 18px;
  width: 100%;
  padding-left: 23px;
  color: var(--pink);

  &.list-inner-item {
    &:hover {
      background-color: var(--semi-brown);
      text-decoration: underline;
    }
  }
`;

export const PageTitle = styled.div`
  display: flex;
  align-items: center;
  padding-top: 45px;
  span {
    width: 10px;
    background-color: var(--pink);
    height: 52px;
  }

  .title {
    margin-left: 20px;
    font-size: 36px;
    font-weight: bold;
    color: var(--dark);
  }

  a {
    display: block;
    margin-left: 24px;
    border-radius: 10px;
    cursor: pointer;
    background-color: var(--pink);
    color: var(--white);
    margin-top: 4px;
    padding: 8px 20px;
  }
  @media (max-width: 768px) {
    padding-top: 24px;
    span {
      width: 5px;
      height: 32px;
    }
    .title {
      margin-left: 12px;
      font-size: 24px;
    }

    a {
      padding: 8px 12px;
      font-size: 14px;
      border-radius: 5px;
    }
  }
`;

export const ImgHolderFullsize = styled.div`
  background-color: var(--pink);
  width: 100%;
  padding-top: 16px;
  margin-top: 16px;
  border-radius: 28px;
  .holder-img {
    width: calc(100% - 32px);
    border-radius: 20px;
    margin: auto;
    display: block;
    height: 400px;
    object-fit: cover;
  }

  .holder-name {
    padding-top: 12px;
    padding-bottom: 12px;
    font-size: 20px;
    text-align: center;
    color: var(--white);
    span {
      display: block;
      font-size: 14px;
    }
  }

  .plus {
    object-fit: cover;
  }

  @media (max-width: 768px) {
    margin-top: 12px;
    border-radius: 15px;
    padding-top: 12px;
    .holder-img {
      border-radius: 10px;
      height: 120px;
      width: calc(100% - 24px);
    }
    .holder-name {
      font-size: 14px;
      padding-top: 6px;
      padding-bottom: 6px;
    }
  }
`;
export const ImgHolderFlex = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 16px;

  &.center {
    justify-content: center;
    gap: 24px;
    img {
      width: 40%;
    }
  }
  .fullsizeItem {
    width: 50% !important;
  }
  @media (max-width: 768px) {
    margin-top: 12px;
    align-items: unset;
    &.center {
      justify-content: center;
      gap: 12px;

      & > img {
        height: 120px;
      }
    }
  }
`;
export const ImgHolderHarf = styled.div`
  background-color: var(--semi-brown);
  width: calc(50% - 8px);
  padding-top: 16px;

  border-radius: 28px;
  .holder-img {
    width: calc(100% - 32px);
    border-radius: 20px;
    margin: auto;
    display: block;
    height: 300px;
    object-fit: cover;
  }

  .holder-name {
    padding-top: 12px;
    padding-bottom: 12px;
    font-size: 20px;
    text-align: center;
    color: var(--dark);
    span {
      display: block;
      font-size: 14px;
    }
  }
  @media (max-width: 768px) {
    border-radius: 15px;
    width: calc(50% - 8px);

    padding-top: 12px;
    .holder-img {
      border-radius: 10px;
      height: 120px;
      width: calc(100% - 24px);
    }
    .holder-name {
      font-size: 14px;
      padding-top: 6px;
      padding-bottom: 6px;
      font-weight: bold;
      span {
        font-size: 10px;
        font-weight: normal;
        word-break: keep-all;
      }
    }
  }
`;

export const HistoryTable = styled.div`
  width: 100%;
  border-radius: 10px;
  border: 1px solid var(--pink);
  margin-top: 24px;
  overflow: hidden;

  .history-table-head {
    border-bottom: 1px solid var(--pink);
    display: flex;
    align-items: center;
    background-color: var(--pink);
    color: #fff;
    font-size: 16px;
    font-weight: bold;
    .history-table-ceil-big {
      padding-left: 20px;
    }
  }

  .history-table-line {
    border-bottom: 1px solid var(--pink);
    display: flex;

    font-size: 14px;
    font-weight: bold;
  }

  .history-table-ceil-small {
    width: 150px;
    border-right: 1px solid var(--pink);
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 16px;
    padding-top: 16px;
  }
  .history-table-ceil-big {
    width: calc(100% - 150px);
    text-align: left;
    padding-bottom: 16px;
    padding-top: 16px;
  }

  .history-table-ceil-big > div {
    padding-left: 16px;
    padding-right: 16px;
  }
  .last-line {
    border-bottom: 0px !important;
  }
  .line {
    width: 100%;
    height: 1px;
    background-color: var(--pink);
    margin-top: 16px;
    margin-bottom: 16px;
  }
  .ceil-kor {
    font-weight: bold;
    @media (max-width: 768px) {
      word-break: keep-all;
    }
  }
  .ceil-end {
    font-weight: lighter;
  }
`;

export const SaleItemList = styled.div`
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 24px;
`;
export const SaleItem = styled.div`
  width: calc((100% - 48px) / 3);
  background-color: var(--pink);
  border-radius: 20px;
  padding-top: 12px;
  padding-bottom: 12px;
  > img {
    width: calc(100% - 56px);
    padding: 16px;
    display: block;
    margin: auto;
    border-radius: 15px;
    height: 123px;
    background-color: var(--white);
  }
`;

export const MuseumTextItemLine = styled.div`
  display: flex;
  margin-top: 12px;
  gap: 12px;
  flex-wrap: wrap;
`;

export const MuseumImgItemLine = styled.div`
  display: flex;
  margin-top: 12px;
  gap: 12px;
  flex-wrap: wrap;
`;

export const MuseumTextItem = styled.div`
  width: calc((100% - 60px) / 6);
  border: 1px solid ${(props) => props.color};
  box-sizing: border-box;
  border-radius: 10px;

  @media (max-width: 1280px) {
    width: calc((100% - 24px) / 3);
  }

  @media (max-width: 768px) {
    width: calc((100% - 24px) / 2);
  }
  @media (max-width: 408px) {
    width: 100%;
  }
  .museum-top {
    background-color: ${(props) => props.color};
    text-align: center;
    padding-top: 8px;
    padding-bottom: 8px;
    color: var(--white);
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;

    .museum-title {
      font-size: 14px;
    }

    .museum-subtitle {
      font-size: 10px;
    }
  }

  .museum-bottom {
    width: calc(100% - 16px);
    padding: 8px;

    & > .intro-title {
      font-szie: 14px;
      font-weight: bold;
      margin-top: 8px;
    }

    & > .intro-title:first-child {
      margin-top: 0px;
    }

    .intro-text {
      font-size: 14px;
      color: var(--strong-brown);
    }

    .intro-text-sm {
      font-size: 12px;
      color: var(--strong-brown);
    }
  }
`;

export const MuseumImgItem = styled.div`
  width: calc((100% - 24px) / 3);
  box-sizing: border-box;
  border-radius: 10px;
  @media (max-width: 1280px) {
    width: calc((100% - 24px) / 3);
  }

  @media (max-width: 768px) {
    width: calc((100% - 24px) / 2);
  }
  @media (max-width: 408px) {
    width: 100%;
  }
  .museum-item-top {
    background-color: ${(props) => props.color};
    text-align: center;
    padding-top: 8px;
    padding-bottom: 8px;
    color: var(--white);
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
  }

  .museum-item-subtitle {
    font-size: 12px;
  }

  .museum-item-img {
    width: 100%;
    height: 255px;
    object-fit: cover;
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;
  }
`;
